import { ShowHideTable } from "../../NewProductCategories/ProductDetails/components/ShowHideTable";
import "./index.css";
import { getAllComponentList } from "../../../apis/Product/ComponentApi";
import { useEffect, useState, useMemo } from "react";
import PieChartWithCenterLabel from "./PieChartWithCenterLabel";
import OverviewMagnify from "./OverviewMagnify";
import ZoomOut from "../../../assets/yfs-label-retrieve/Subtract magnify.svg";
import { useTranslation } from "react-i18next";

const PercentageBreakdownPie = ({ productId }) => {
  const { t } = useTranslation();
  const [fullPercentage, setFullPercentage] = useState([]);
  const [isZoomed, setIsZoomed] = useState(false);
  const [show, setShow] = useState(false);

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  useEffect(() => {
    getAllComponentList({
      productId: productId,
      subcategoryId: null,
      setFullPercentage: setFullPercentage,
    });
  }, [productId]);

  const slicedData = useMemo(() => {
    return fullPercentage.slice(0, 3);
  }, [fullPercentage]);
  return (
    <OverviewMagnify
      toggleZoom={toggleZoom}
      setIsZoomed={setIsZoomed}
      isZoomed={isZoomed}
    >
      <div
        className="product-pie-bg"
        style={{ minWidth: isZoomed ? "350px" : "none" }}
      >
        {isZoomed && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              marginBottom: "5px",
            }}
          >
            <button
              onClick={toggleZoom}
              className="zoom-button modal-zoom-button"
            >
              <img src={ZoomOut} alt="Zoom Out Icon" />
            </button>
          </div>
        )}
        <h5 className="product-pie-title">{t("IMPACT_BREAKDOWN_PRODUCT")}</h5>
        <PieChartWithCenterLabel
          data={fullPercentage}
          slicedData={slicedData}
          show={show}
          centerText={"Total CO₂e (kg)"}
          unit={"CO₂e(kg)"}
          isZoomed={isZoomed}
        />
        {!isZoomed && <ShowHideTable showTable={show} setShowTable={setShow} />}
      </div>
    </OverviewMagnify>
  );
};

export default PercentageBreakdownPie;
